import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FavoriteItem, ProceduresState } from "./index.types";

const initialState: ProceduresState = {
  unfavoritedProcedures: [],
};

export const proceduresSlice = createSlice({
  name: "procedures",
  initialState,
  reducers: {
    addUnfavoritedProcedure: (state, action: PayloadAction<FavoriteItem>) => {
      state.unfavoritedProcedures.push(action.payload);
    },
    resetUnfavoritedProcedures: (state) => {
      state.unfavoritedProcedures = [];
    },
  },
});

export const { addUnfavoritedProcedure, resetUnfavoritedProcedures } = proceduresSlice.actions;

export const selectUnfavoritedProcedures = (state: any) => state.procedures.unfavoritedProcedures;

export default proceduresSlice.reducer;
